import { ConditionalLogic, FormQuestion } from '../types'

export type AnswerMap = Record<string, string | string[]>

function asText(value: string | string[] | undefined): string {
  if (value === undefined) return ''
  return Array.isArray(value) ? value.join('|') : String(value)
}

function isAnswered(value: string | string[] | undefined): boolean {
  if (value === undefined) return false
  if (Array.isArray(value)) return value.length > 0
  return String(value).trim().length > 0
}

/** Evalúa la lógica condicional de una pregunta contra las respuestas actuales. */
export function shouldShowQuestion(
  question: FormQuestion,
  answers: AnswerMap,
): boolean {
  if (!question.isActive) return false
  const logic: ConditionalLogic | undefined = question.conditionalLogic
  if (!logic || !logic.enabled || !logic.questionId) return true

  const target = answers[logic.questionId]
  const text = asText(target).toLowerCase()
  const expected = (logic.value || '').toLowerCase()

  switch (logic.operator) {
    case 'igual':
      return Array.isArray(target)
        ? target.map((v) => v.toLowerCase()).includes(expected)
        : text === expected
    case 'distinto':
      return Array.isArray(target)
        ? !target.map((v) => v.toLowerCase()).includes(expected)
        : text !== expected
    case 'contiene':
      return text.includes(expected)
    case 'no_contiene':
      return !text.includes(expected)
    case 'respondida':
      return isAnswered(target)
    case 'no_respondida':
      return !isAnswered(target)
    default:
      return true
  }
}

export function visibleQuestions(
  questions: FormQuestion[],
  answers: AnswerMap,
): FormQuestion[] {
  return [...questions]
    .sort((a, b) => a.order - b.order)
    .filter((q) => shouldShowQuestion(q, answers))
}
